import { ModalPropsType } from "./types";

export const MODAL_PROPS: ModalPropsType = {
  DRAFT: {
    pTitle: "Remove entire draft?",
    pPrimaryButtonText: "Yes, remove draft",
    pSecondaryButtonText: "No, keep draft",
    pContent:
      "Removing the draft will delete the complete draft, including assets and metadata. Are you sure you want to remove this draft?",
  },
  SUBMITTED: {
    pTitle: "Cancel this request?",
    pPrimaryButtonText: "Yes, cancel request",
    pSecondaryButtonText: "No, keep request",
    pContent:
      "Cancelling will permanently delete this request, including all assets, metadata and any feedback or comments already added. This can't be undone.",
  },
};
